<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text" v-html="input.addon"></span>
    </div>
    <input
      :type="input.addonType == 'text' ? 'text' : 'number'"
      :class="'form-control ' + input.class"
      :value="value"
      @input="(e) => handleChange(e)"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :readonly="input.readonly"
      :name="input.name"
    />
  </div>
</template>
<script>
export default {
  name: "InputAddonLeft",
  components: {},
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
